import React from 'react';
import { connect } from 'react-redux';
import Message from '../../../components/message/index';
import { getAdminReportList,adminReportUpdateStatus} from '../../../actions/actions';

class AdminReportList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SmsProcessInfo: [],
            selectedUser: null,
            searchText: null,
            tempUserList: [],
            showConfirmOkPopup: false,
            selectedIndex: 0,
        }
        this.getUserList = this.getUserList.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        this.getUserList();
    }

    getUserList() {
        getAdminReportList((data) => {
            this.setState({
                SmsProcessInfo: data.SmsProcessInfo,
            })
        });
    }

    updateState() {
        this.showConfirmOkPopupState(false);
        let data = this.state.SmsProcessInfo[this.state.selectedIndex];

        this.props.dispatch(adminReportUpdateStatus(data.id, (res) => {
                this.setState({
                    SmsProcessInfo: res.SmsProcessInfo,
                });
        }, (error) => {
            console.log("Error");
        }));
    }

    showConfirmOkPopupState(state, item) {
        this.setState({
            showConfirmOkPopup: state,
            selectedIndex: item
        });

        console.log(this.state.selectedIndex);
    }


    handleItemClick(index) {
        this.setState({ selectedUser: this.state.SmsProcessInfo[index] });
    }

    handleSearch(e) {
        if (e.target.value != null && e.target.value != "") {
            if (this.state.tempUserList.length === 0) {
                this.setState({ tempUserList: this.state.SmsProcessInfo, SmsProcessInfo: this.state.SmsProcessInfo.filter(partner => partner.requestName.toLowerCase().includes(e.target.value.toLowerCase())) });
            } else {
                this.setState({ SmsProcessInfo: this.state.tempUserList.filter(partner => partner.requestName.toLowerCase().includes(e.target.value.toLowerCase())) });
            }
        } else {
            this.setState({ SmsProcessInfo: this.state.tempUserList, tempUserList: [] });
        }
    }

    formatDate(dateStr) {
        const datePart = dateStr.slice(0, 8);
        const timePart = dateStr.slice(9);
        
        const day = datePart.slice(0, 2);
        const month = datePart.slice(2, 4);
        const year = datePart.slice(4, 8);

        const formattedDate = `${day}.${month}.${year} ${timePart}`;
        return formattedDate;
      }

      checkStatusIsPullMsisdnList(index){
        const selectedItem=this.state.SmsProcessInfo[index];
        if(selectedItem.status === "PULL_MSISDN_LIST"){
            return false;
        }
        return true;
    }


    render() {


        return (
            [
                <section className="panel">
                    <Message />
                    <div className="container">
                        <div className="table">
                            <div className="top">
                                <div className="title-default">
                                    Gönderim Listesi
                                </div>
                                <div className="actions"></div>
                            </div>
                            <div className="bottom">
                                <div className="table-container">
                                    <div className="form-item" style={{ margin: '20px' }}>
                                        <label>Gönderim Ara</label>
                                        <input type="text" placeholder="Gönderim araması yapınız" value={this.state.searchText} onChange={this.handleSearch.bind(this)} />
                                    </div>
                                    <table className="sortable">
                                        <thead>
                                            <tr>
                                                <th><span>Gönderim Adı</span></th>
                                                <th><span>Mesaj İçeriği</span></th>
                                                <th><span>Kullanıcı</span></th>
                                                <th><span>Gönderim Tarihi</span></th>
                                                <th><span>Gönderim Durumu</span></th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.SmsProcessInfo && this.state.SmsProcessInfo.map((item, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{item.requestName}</td>
                                                        <td>{item.message}</td>
                                                        <td>{item.partnerName}</td>
                                                        <td>{this.formatDate(item.earliestSendDate)} - {this.formatDate(item.latestSendDate)}</td>
                                                        <td>{item.status}</td>
                                                        <td>
                                                        {this.checkStatusIsPullMsisdnList(i) ?
                                                                <div></div> 
                                                                :
                                                            <button className="btn primary" onClick={() => this.showConfirmOkPopupState(true, i)}>
                                                                <span>Statü İlerlet</span>
                                                            </button>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div>
                            {this.state.showConfirmOkPopup &&
                            <div className="popup-wrapper active">
                                <div className="popup-container">
                                    <div className="popup-title small">
                                        Statü İlerletme İşlemini Onaylıyor musunuz?
                                    </div>
                                    <div className="form-container">
                                        <a id={"admin-approve-okey"} className="btn primary"
                                           title="Onayla" onClick={() => this.updateState()}>
                                            <span>Evet</span>
                                        </a>
                                        <a id={"admin-approve-cancel"} className="btn" href="javascript:void(0)"
                                           title="İptal" onClick={() => this.showConfirmOkPopupState(false)}>
                                            <span>İptal</span>
                                        </a>
                                    </div>
                                </div>
                                <a className="popup-close" href="javascript:void(0)"
                                   onClick={() => this.showConfirmOkPopupState(false)}>
                                    <img src={require('../../../assets/icons/icon-popup-close.svg')} alt="Kapat Ikonu"/>
                                </a>
                            </div>
                            }
                        </div>

                    </div>
                </section>
            ]
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

export default connect(mapStateToProps)(AdminReportList)